import * as tslib_1 from "tslib";
// Core components
import { SimpleChange } from "@angular/core";
import { MatDialog } from "@angular/material";
// Third party components
import { FieldArrayType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
// Custom components
/**
 * Script start
 */
var RepeatDocTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatDocTypeComponent, _super);
    function RepeatDocTypeComponent(translateService, dialog) {
        var _this = _super.call(this) || this;
        _this.translateService = translateService;
        _this.dialog = dialog;
        _this.subscriptions = [];
        _this.onDestroy$ = new Subject();
        _this.availableOptions = [];
        _this.delBntenable = true;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    RepeatDocTypeComponent.prototype.ngOnInit = function () {
        this.to.add = this.add.bind(this);
        this.to.remove = this.remove.bind(this);
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    RepeatDocTypeComponent.prototype.ngOnChanges = function (changes) {
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    RepeatDocTypeComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle click on "add new row" button and add a new row's input template
     *
     * @since 1.0.0
     */
    RepeatDocTypeComponent.prototype.onAddRow = function () {
        this.add();
        // this.add(null, {});
    };
    return RepeatDocTypeComponent;
}(FieldArrayType));
export { RepeatDocTypeComponent };
